import { render, staticRenderFns } from "./preregistro_email.vue?vue&type=template&id=289fad96&scoped=true"
import script from "./preregistro_email.vue?vue&type=script&lang=js"
export * from "./preregistro_email.vue?vue&type=script&lang=js"
import style0 from "./preregistro_email.vue?vue&type=style&index=0&id=289fad96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289fad96",
  null
  
)

export default component.exports